<template>
  <div class="home">
    <!-- 头图 -->
    <div class="banner">
      <div class="banner-img">
        <img src="./img1/banner.png" alt="">
      </div>
    </div>

    <div class="box1">
      <div class="container">
        <div class="text">
          随着国内移动支付占比率不断提升，银行机构为了保持核心竞争力不断创新业务。而其业务持续性及事务处理即时性对系统要求设置了“紧箍咒”。特别是伴随网络攻击尤其勒索病毒肆虐，金融行业需要全面掌控关键数据安全风险。
        </div>
      </div>
      
    </div>
    
    <div class="box2">
      <div class="container">
        <div class="text">
          <div class="mbtitle">勒索病毒的金融行业环游记</div>
          <div class="box2img">
            <img src="./img1/box2-img.jpg" alt="">
          </div>
          <div class="box2read">
            <div class="readtx">
              亲爱的观众朋友：<br>
              经过医疗，制造业环游记的两轮“洗礼”，我深入研究了人类分析机构的行业报告，痛定思痛，决定换个方向重新出发，誓要将环游记进行到底！是的，我对资金业务最繁重的金融行业下手了！
              <div class="readbtn" @click="toUrl('https://www.doit.com.cn/p/483358.html')">阅读全文</div>
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <div class="box3">
      <img src="./img1/box3.png" alt="">
    </div>

    <div class="box4">
      <div class="container">
        <div class="text">
          <div class="mbtitle">数据保护攻略篇</div>
          <div class="box4-title">应对不同安全风险的数据保护方案，专家大咖云集，为企业提供超实用攻略！</div>
          <div class="box4-box">
            <div class="box4-item" v-for="(item, index) in pdf" :key="index"  @click="download(item.herf)">
              <div>
                <img :src="item.img" alt="">
              </div>
              <div>
                <div class="box4tx">{{item.title}}</div>
                <!-- <div class="box4btn">点击下载</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box5">
      <div class="container">
        <div class="text">
          <div class="mbtitle">打开数据保护新视界</div>
          <div class="box5-title">打开新视界，从不同角度，看数据避风港如何加强对勒索病毒、破坏性网络攻击的防护，为企业保驾护航。</div>
          <div class="box5-box">
            <div class="box5-item" v-for="(item, index) in video" :key="index">
              <img :src="item.img" alt="" @click="toUrl(item.herf)">
              <div class="box5-play">
                <img src="./img1/box5play.png" alt="">
                <div class="box5-intro">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="box6">
      <div class="container">
        <div class="text">
          <div class="mbtitle">聚焦市场新动向</div>
          <div class="box6-title">防御网络攻击时刻不能松懈，需要了解行业市场最新动态，以专注的态度应对不期而至的挑战。</div>
          <div class="box6-box">
            <div class="box6-item" v-for="(item, index) in news" :key="index" @click="toUrl(item.herf)">
              <img src="./img1/box6-1.png" alt="">
              <div>{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box7">
      <img src="./img1/box7.png" alt="">
    </div>
      <!-- <div class="outswiper">
        <swiper
          :modules="modules"
          class="swiper-w"
          :slides-per-view="3"
          :space-between="20"
          navigation
        
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            v-for="(item, index) in yth"
            :key="index"
            @click="toUrl(item)"
          >
            <div class="yth-item">
              <div class="yth-name">{{ item.text }}</div>
              <div class="yth-img">
                <img :src="item.img" alt="" />
                <div class="yth-play">
                  <img src="./img/播放.png" alt="">
                </div>
              </div>
              
              
            </div>
          </swiper-slide>
        </swiper>
        <swiper
          :modules="modules"
          class="swiper-m"
          :slides-per-view="1"
          :space-between="5"
          navigation
        
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            v-for="(item, index) in yth"
            :key="index"
            @click="toUrl(item)"
          >
            <div class="yth-item">
              <div class="yth-name">{{ item.text }}</div>
              <div class="yth-img">
                <img :src="item.img" alt="" />
                <div class="yth-play">
                  <img src="./img/播放.png" alt="">
                </div>
              </div>
              
              
            </div>
          </swiper-slide>
        </swiper>
      </div> -->

    
    <!-- 第一模块轮播 -->
    <!-- 
        navigation 左右按钮 
        loop 循环   
      -->
    <!-- <div class="h3c-1">
      <div class="container">
        <div class="h3c-title">
          <img :src="title1" alt="" />
        </div>
        <div class="dian">
          <img src="./images/dian.png" alt="" />
        </div>
        <div class="floatwindow" @click="windowTo">
          <img src="./images/box.png" alt="" />
        </div>
        <div class="h3c-1-text">
          如何让企业以有限的预算拥有强大、灵活、可增长性高、运维便捷的计算存储解决方案，帮助您专注自身业务，无需为数字化转型担忧？那么请不要错过以下精彩专题分享！
        </div>
        <swiper
          :modules="modules"
          class="swiper-w"
          :slides-per-view="3"
          :space-between="10"
          navigation
          :pagination="{ clickable: true }"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            v-for="(item, index) in lists"
            :key="index"
            @click="toUrl(item)"
          >
            <div class="h3c-img">
              <img :src="item.img" alt="" />
              <div class="h3c-video">{{ item.text }}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div> -->

    
  </div>
</template>

<script>
import { login } from "@/api/register.js";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay, Navigation, A11y, Pagination } from "swiper";
import "swiper/swiper-bundle.css";
SwiperCore.use([Autoplay, Navigation, Pagination, A11y]);
import "./index.css";
export default {
  name: "SwiperIndex",
  data() {
    return {
      pdf: [
        {
          id: 1,
          img: require('./img1/pdf1.png'),
          title: '数据避风港技术白皮书',
          herf:
            'https://e.cn.miaozhen.com/r/k=2279182&p=8DKtr&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o=https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205158364/2207111065526225?v=media&utm_medium=ff_md_md&utm_source=doit&utm_campaign=doit-dps-fy23q3&utm_content=helen-wu_isg&utm_term=doit-2207111065526225_23q3dps&gacd=9788180-2279182-0-8DKtr-0&dgc=ba&cid=2279182&lid=8DKtr'
        },
        {
          id: 2,
          img: require('./img1/pdf2.png'),
          title: 'Smart Scale解决方案简述',
          herf:
            'https://e.cn.miaozhen.com/r/k=2279182&p=8DKts&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o=https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205157909/2207070630075437?v=media&utm_medium=ff_md_md&utm_source=doit&utm_campaign=doit-dps-fy23q3&utm_content=helen-wu_isg&utm_term=doit-2207070630075437_23q3dps&gacd=9788180-2279182-0-8DKts-0&dgc=ba&cid=2279182&lid=8DKts'
        },
        {
          id: 3,
          img: require('./img1/pdf3.png'),
          title: '信赖戴尔数据避风港的五大理由',
          herf:
            'https://e.cn.miaozhen.com/r/k=2279182&p=8DKtu&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o=https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205153016/2205270813694717?v=media&utm_medium=ff_md_md&utm_source=doit&utm_campaign=doit-dps-fy23q3&utm_content=helen-wu_isg&utm_term=doit-2205270813694717_23q3dps&gacd=9788180-2279182-0-8DKtu-0&dgc=ba&cid=2279182&lid=8DKtu'
        },
        {
          id: 4,
          img: require('./img1/pdf4.png'),
          title: '构建现代数字校园，创新培育文化俊才',
          herf:
            'https://e.cn.miaozhen.com/r/k=2279182&p=8DKu1&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o=https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205157524/2207040145499227?v=media&utm_medium=ff_md_md&utm_source=doit&utm_campaign=doit-dps-fy23q3&utm_content=helen-wu_isg&utm_term=doit-205157524_23q3dps&gacd=9788180-2279182-0-8DKu1-0&dgc=ba&cid=2279182&lid=8DKu1'
        },
        {
          id: 5,
          img: require('./img1/pdf5.png'),
          title: '戴尔PPDM Avamar PPDP Savills 客户案例',
          herf:
            'https://e.cn.miaozhen.com/r/k=2279182&p=8DKtz&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o=https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/205157604/2207050033635464?v=media&utm_medium=ff_md_md&utm_source=doit&utm_campaign=doit-dps-fy23q3&utm_content=helen-wu_isg&utm_term=doit-2207050033635464_23q3dps&gacd=9788180-2279182-0-8DKtz-0&dgc=ba&cid=2279182&lid=8DKtz'
        },
        {
          id: 6,
          img: require('./img1/pdf6.png'),
          title: '戴尔PPDM & 数据避风港_Léon Bérard区域医疗中心_客户案例',
          herf:
            'https://e.cn.miaozhen.com/r/k=2279182&p=8DKu3&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o=https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/details/2206232470007516?v=media&utm_medium=ff_md_md&utm_source=doit&utm_campaign=doit-dps-fy23q3&utm_content=helen-wu_isg&utm_term=doit-2206232470007516_23q3dps&gacd=9788180-2279182-0-8DKu3-0&dgc=ba&cid=2279182&lid=8DKu3'
        }
      ], 
      video: [
        {
          id: 1,
          img: require('./img1/video1.png'),
          title: ' 数据风险无踪，尽在你我掌控',
          info: '戴尔数据保护解决方案客户案例视频',
          herf:
            'https://e.cn.miaozhen.com/r/k=2279182&p=8DKtn&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o=https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/details/2207082468567083?v=media&utm_medium=ff_md_md&utm_source=doit&utm_campaign=doit-dps-fy23q3&utm_content=helen-wu_isg&utm_term=doit-2207082468567083_23q3dps&gacd=9788180-2279182-0-8DKtn-0&dgc=ba&cid=2279182&lid=8DKtn'
        },
        {
          id: 2,
          img: require('./img1/video2.png'),
          title: '戴尔多云数据保护解决方案',
          info: '久经验证的现代化解决方案',
          herf:
            'https://e.cn.miaozhen.com/r/k=2279182&p=8DKti&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o=https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/details/2203221732020809'
        },
        {
          id: 3,
          img: require('./img1/video3.png'),
          title: '数据避风港演示',
          info: '',
          herf:
            'https://e.cn.miaozhen.com/r/k=2279182&p=8DKtp&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o=https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/details/2207080925419307?v=media&utm_medium=ff_md_md&utm_source=doit&utm_campaign=doit-dps-fy23q3&utm_content=helen-wu_isg&utm_term=doit-2207080925419307_23q3dps&gacd=9788180-2279182-0-8DKtp-0&dgc=ba&cid=2279182&lid=8DKtp'
        },
        {
          id: 4,
          img: require('./img1/video4.png'),
          title: '数据驱动智能管理',
          info: '',
          herf:
            'https://e.cn.miaozhen.com/r/k=2279182&p=8DKtq&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o=https://www.dellemc-solution.com/campaign/dps_collect?backUrl=https://www.dellemc-solution.com/campaign/dps_library/details/2206082032003042?v=media&utm_medium=ff_md_md&utm_source=doit&utm_campaign=doit-dps-fy23q3&utm_content=helen-wu_isg&utm_term=doit-2206082032003042_23q3dps&gacd=9788180-2279182-0-8DKtq-0&dgc=ba&cid=2279182&lid=8DKtq'
        }
      ],
      news: [
        {
          id: 1,
          title: '【业界动态】应对数据风险的“三位一体”安全解决方案',
          herf: 'https://mp.weixin.qq.com/s/JVtGfoO6E1HhHnc11jePKg'
        },
        {
          id: 2,
          title: '勒索病毒环游记之速度与激情篇',
          herf: 'https://www.doit.com.cn/p/480600.html'
        },
        {
          id: 3,
          title: '黑客：你要悄悄变富，然后惊艳所有人……',
          herf: 'https://mp.weixin.qq.com/s/lZ0pB4x7gql4jWzeAbPuqA'
        },
        {
          id: 4,
          title: '这招“三板斧”，勒索病毒谁敢接着？',
          herf: 'https://mp.weixin.qq.com/s/4wmUmqWkJe9Z4vdZzm1SOA'
        }
      ], 
    };
  },
  props: {
    /* list:{
      type: Array,
      required: true
    } */
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const onSwiper = (swiper) => {};
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, A11y, Autoplay],
    };
  },
  mounted() {},
  methods: {
    // 下载文件
    download (item) {
      window.location.href = item
    },
    toUrl(item) { 
      window.location.href = item;

    },
    toUrl1(item,index) {
       window.location.href = item.url;
       this.bgcs = index
    },
    //浮窗跳转
    windowTo() {
      window.location.href = this.windowUrl;
    },
    tendTo(key) {
      if(key.id) {
        document.getElementById(`${key.id}`).scrollIntoView({
         behavior: 'smooth',
         block: 'center'
        })
      } else {
        window.location.href = key.url;
      }
      
    }
  },
};
</script>

<style scoped lang='less'>
</style>
